import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

import Activity from "components/DigiHapi/Activity";
import Notification from "components/DigiHapi/Notification";
import CommunityInfoCard from "components/DigiHapi/CommunityInfoCard";

import { GrOrganization } from "react-icons/gr";

import { fetchGetCommunityDetails } from "actions/community";
import { fetchGetOrganizationDetails } from "actions/organization";

// Redux
import { useDispatch, useSelector } from "react-redux";

import {
	CLEAR_ORGANIZATION,
	RESET_ORGANIZATION,
	ROLE_ADMINISTRATOR,
	ROLE_WEBMASTER
} from "actions/types";
import Organizations from "./Organizations/OrganizationsPage";

export default function OrganizationPage() {
	const dispatch = useDispatch();

	const { organization, community } = useSelector(
		state => state.entitiesReducer
	);

	const { user } = useSelector(state => state.profileReducer);

	const { isFetching, newWizard, snackInfoMsg, snackErrorMsg } = useSelector(
		state => state.organizationReducer
	);

	const [br, setBr] = useState(false);
	const [message, setMessage] = useState(null);
	const [color, setColor] = useState("info");
	const [wizard, setWizard] = useState(null);

	const getOrganizationDetails = () => {
		dispatch(fetchGetOrganizationDetails(organization._id));
	};

	const getCommunityDetails = () => {
		dispatch(fetchGetCommunityDetails(organization._id));
	};

	useEffect(() => {
		if (snackInfoMsg || snackErrorMsg) {
			if (snackInfoMsg) {
				setWizard(null);
				getCommunityDetails();
			}
			setBr(true);
			setMessage(snackInfoMsg ? snackInfoMsg : snackErrorMsg);
			setColor(snackInfoMsg ? "info" : "danger");
			if (snackInfoMsg) {
				setTimeout(() => setBr(false), 5000);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [snackInfoMsg, snackErrorMsg]);

	const onClose = () => {
		setWizard(null);
		dispatch({
			type: RESET_ORGANIZATION
		});
	};

	useEffect(() => {
		if (newWizard) {
			const wizard = (
				<Organizations.OrganizationsWizard onClose={onClose} update />
			);
			setWizard(wizard);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newWizard]);

	useEffect(() => {
		if (user.role === ROLE_WEBMASTER) {
			dispatch({
				type: CLEAR_ORGANIZATION
			});
		} else {
			getCommunityDetails();
		}
	}, []);

	const {
		logoUri,
		name,
		phone,
		mail,
		webSiteUrl,
		qrcodeUri,
		address,
		zipCode,
		city
	} = organization;

	const actions =
		user.role === ROLE_ADMINISTRATOR || user.role === ROLE_WEBMASTER
			? [
					{
						tooltip: "Modifier",
						icon: "edit",
						color: "info",
						disabled: wizard !== null,
						onClick: getOrganizationDetails
					}
			  ]
			: [];

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} sm={6} lg={4}>
				{isFetching ? (
					<Activity />
				) : (
					<CommunityInfoCard
						logoUri={logoUri}
						icon={<GrOrganization />}
						name={name}
						qrcodeUri={qrcodeUri}
						actions={actions}
						address={address}
						zipCode={zipCode}
						city={city}
						phone={phone}
						mail={mail}
						webSiteUrl={webSiteUrl}
					/>
				)}
			</Grid>
			{wizard && (
				<Grid item xs={12}>
					{wizard}
				</Grid>
			)}
			<Notification
				place="br"
				color={color}
				message={message}
				open={br}
				onClose={() => setBr(false)}
			/>
		</Grid>
	);
}
